import React, { createContext, useContext, useRef, useState } from "react";
import API from "../Helper/server/API";
import { baseUrl } from "../Helper/links";

const WhatsappContext = createContext();

export const WhatsappProvider = ({ children }) => {
    const msgs = useRef(null);
    const [loading_whatsapp, set_loading_whatsapp] = useState(false);

    const delay = (ms) => new Promise((res) => setTimeout(res, ms));

    const SendWhatsAppMsg = async (endPoint, data) => {
        if (!loading_whatsapp) {
            set_loading_whatsapp(true)
            const response = await API.post(endPoint, data)

            if (response?.success === 1) {
                msgs.current.clear();
                msgs.current.show([
                    {
                        severity: 'success', detail: '', summary: '', closable: true, life: 5000, style: {
                            height: "3rem",
                        },
                        content: (
                            <React.Fragment>
                                <i className="pi pi-whatsapp pl-2"></i>
                                <div className="ml-2">{response?.msg}</div>
                            </React.Fragment>
                        )
                    }
                ]);
            }
            else if (response?.success === 0) {
                msgs.current.clear();
                msgs.current.show([
                    {
                        severity: 'warn', detail: '', summary: '', closable: true, life: 5000, style: {
                            height: "3rem",
                        },
                        content: (
                            <React.Fragment>
                                <i className="pi pi-whatsapp pl-2"></i>
                                <div className="ml-2">{response?.msg}</div>
                            </React.Fragment>
                        )
                    }
                ]);
            }
            else {
                msgs.current.show([
                    {
                        severity: 'warn', detail: '', summary: '', closable: true, life: 5000, style: {
                            height: "3rem",
                        },
                        content: (
                            <React.Fragment>
                                <i className="pi pi-whatsapp pl-2"></i>
                                <div className="ml-2">لــم يتــم إرســال واتســاب</div>
                            </React.Fragment>
                        )
                    }
                ]);
            }
            set_loading_whatsapp(false)
        }

    };
    const SendWhatsAppMsgTest = async () => {
        set_loading_whatsapp(true);

        await delay(5000);
        msgs.current.clear();
        msgs.current.show([
            {
                severity: 'warn', detail: '', summary: '', closable: true, life: 5000, style: {
                    height: "3rem",
                },
                content: (
                    <React.Fragment>
                        <i className="pi pi-whatsapp pl-2"></i>
                        <div className="ml-2">لــم يتــم إرســال واتســاب</div>
                    </React.Fragment>
                )
            }
        ]);

        set_loading_whatsapp(false);
    };

    return (
        <WhatsappContext.Provider value={{ SendWhatsAppMsg, SendWhatsAppMsgTest, set_loading_whatsapp, loading_whatsapp, msgs }}>
            {children}
        </WhatsappContext.Provider>
    );
};

// دالة لاستخدام السياق بسهولة في أي مكون
export const useWhatsapp = () => {
    const context = useContext(WhatsappContext);
    if (!context) {
        throw new Error("useWhatsapp يجب أن يكون داخل WhatsappProvider");
    }
    return context;
};
